import { Component } from '@angular/core';
import { environment } from '@ov-suite/helpers-shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Adminlink';
  authCheck = { complete: false };
  dev = !environment.production;
}
